<template>
	<ui-card
		icon="fal fa-check-double"
		title="Duplicidade"
		text="Informe os campos que se deve checar a duplicidade ao se criar uma reserva."
	>
		<template #body>
			<ui-load-success
				v-if="loader.overlay"
				:loading="loader.overlayLoading"
				:success="loader.overlaySucess"
			/>

			<div class="area-card">
				<transition name="small-fade">
					<div v-show="loader.body" class="loading-card">
						<ui-load-indicator bgColor="#e7e9f4" color="#69D296" :h="50" :stroke="8" />
					</div>
				</transition>

				<ui-select-2
					v-model="form.field"
					:data="duplicityFields"
					:search="false"
					label="Selecione os Campos:"
					item-label="label"
					multiple
				/>
			</div>
		</template>
		<template #fl></template>
		<template #fr>
			<ui-button design="md success" :disabled="!canSubmit" @click="submit">Salvar</ui-button>
		</template>
	</ui-card>
</template>
<script>
	import { uiCard } from '@/components/ui/cards'
	import { uiButton } from '@/components/ui/buttons'
	import { uiSelect2 } from '@/components/ui/form'
	import { uiLoadIndicator } from '@/components/ui'
	import { uiLoadSuccess } from '@/components/ui/overlays'

	import { utilMixin, formMixin, alertMixin } from '@/mixins'
	import { getConfig, saveConfig } from '../../util/methods'

	import { duplicityFieldsItems } from '../../util/data'
	import { dafaultOptions, selectOptions } from '../../util/functions'

	const defaultForm = () => ({
		customerDuplicate: null,
		field: [],
	})

	const defaultDisabled = () => ({})

	const defaultChecked = () => ({})

	const defaultLoader = () => ({
		body: false,
		overlay: false,
		overlayLoading: true,
		overlaySucess: true,
	})

	export default {
		name: 'configuration-reserves-duplicity',

		components: {
			uiCard,
			uiButton,
			uiSelect2,
			uiLoadSuccess,
			uiLoadIndicator,
		},

		mixins: [utilMixin, formMixin, alertMixin],

		data() {
			return {
				form: { ...defaultForm() },
				disabled: { ...defaultDisabled() },
				checked: { ...defaultChecked() },
				loader: { ...defaultLoader() },
				duplicityFields: [...dafaultOptions(duplicityFieldsItems)],
				oldForm: {},
			}
		},

		async created() {
			this.loader.body = true

			this.form.customerDuplicate = await this.getConfig('customerDuplicate', 'value_long')
			this.form.field = selectOptions(
				this.form.customerDuplicate.reserve.field,
				duplicityFieldsItems,
			)

			this.loader.body = false
			this.$mx_copyOldForm()
		},

		computed: {
			canSubmit() {
				return this.$mx_isFormChanged && !this.loader.body
			},

			fieldData() {
				let field = []
				this.form.field.forEach((item) => {
					field.push(item.value)
				})
				return field
			},

			customerDuplicateData() {
				let data = this.$mx_copyObject(this.form.customerDuplicate)
				data.reserve.field = this.fieldData
				
				// Replace Array[0] to null
				return this.$mx_replaceDataValue(data, "[[\]]", "[null]")			},
		},

		methods: {
			getConfig,
			saveConfig,

			async submit() {
				try {
					this.loader.overlay = true
					this.loader.overlayLoading = true

					await this.saveConfig(
						'customerDuplicate',
						this.customerDuplicateData,
						'value_long',
					)

					setTimeout(() => {
						this.loader.overlayLoading = false
						this.loader.overlaySucess = true
						setTimeout(() => {
							this.loader.overlay = false
						}, 500)
					}, 500)

					this.$mx_copyOldForm()
					//...
				} catch (error) {
					this.$mx_alertThisOnError(error)
					this.loader.overlaySucess = false
					setTimeout(() => {
						this.loader.overlay = false
					}, 1000)
				}
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
